import { render, staticRenderFns } from "./lxzcOther.vue?vue&type=template&id=78ec7005&scoped=true&"
import script from "./lxzcOther.vue?vue&type=script&lang=js&"
export * from "./lxzcOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ec7005",
  null
  
)

export default component.exports